module.exports = __webpack_public_path__ + "img/a4.41518ed5.png";